export default __webpack_public_path__ + "static/media/loadingDragon.722e10d1.svg";